import clsx from 'clsx'

type HeaderPanelBaseProps = {
  isLoading?: boolean
  children: React.ReactNode
  withPadding?: boolean
  className?: string
}

export function HeaderPanelBase({
  isLoading,
  children,
  withPadding = true,
  className,
}: HeaderPanelBaseProps) {
  return (
    <div
      className={clsx(
        'flex space-x-2 bg-white rounded items-center max-w-md overflow-wrap-anywhere print:p-0',
        withPadding && 'p-4',
        className
      )}
      aria-live="off"
      aria-busy={isLoading}
    >
      {children}
    </div>
  )
}
